module.exports = __webpack_public_path__ + "img/24_51.51f2941a.png";